import ability from './ability'

export const canNavigate = to => { return true; }

export const _ = undefined
